import type { Endpoints } from 'consts/api';
import { FLOW_TYPE } from 'consts/flows';
import { DEFAULT_MIFID_STATUS } from 'consts/statuses';
import type { HTTP } from 'services/http';

export async function getMifidStatus(ssn: string, flowType: string, API: Endpoints, http: HTTP) {
	if (ssn && FLOW_TYPE.ES_MV === flowType) {
		return http.get(`${API.getMifidStatus}?ssn=${ssn}`);
	}
	return DEFAULT_MIFID_STATUS;
}
